import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { useLang } from "../i18n/LanguageContext";
import { api } from "../lib/api";
import PropertyCard from "../components/PropertyCard";
import Filters from "../components/Filters";

const PropertiesPage = () => {
  const { t } = useLang();
  const [searchParams, setSearchParams] = useSearchParams();
  const [properties, setProperties] = useState([]);
  const [zones, setZones] = useState([]);
  const [loading, setLoading] = useState(true);

  const initFilters = {
    contract: searchParams.get("contract") || "all",
    type: searchParams.get("type") || "all",
    zone: searchParams.get("zone") || "all",
    max_price: searchParams.get("max_price") || "",
  };
  const [filters, setFilters] = useState(initFilters);

  const fetchProperties = (f = filters) => {
    setLoading(true);
    const params = new URLSearchParams();
    Object.entries(f).forEach(([k, v]) => {
      if (v !== "" && v !== "all") params.set(k, v);
    });
    api.get(`/properties?${params.toString()}`)
      .then((r) => setProperties(r.data))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    api.get("/zones").then((r) => setZones(r.data)).catch(() => {});
    fetchProperties(initFilters);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const submitFilters = () => {
    const params = new URLSearchParams();
    Object.entries(filters).forEach(([k, v]) => { if (v !== "" && v !== "all") params.set(k, v); });
    setSearchParams(params);
    fetchProperties(filters);
  };

  return (
    <div data-testid="properties-page" className="fade-in">
      <section className="bg-[#F3E6DA] py-16 md:py-24 grain relative">
        <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-16 relative">
          <p className="text-[11px] uppercase tracking-[0.28em] font-bold text-[#8B5A3C] mb-4">{t.nav.properties}</p>
          <h1 className="font-display text-5xl sm:text-6xl font-medium leading-[1.05] tracking-tight text-[#2C2621] max-w-2xl">
            {t.filters.title}
          </h1>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-6 md:px-10 lg:px-16 -mt-10 mb-12">
        <Filters values={filters} onChange={setFilters} onSubmit={submitFilters} zones={zones} compact />
      </section>

      <section className="max-w-7xl mx-auto px-6 md:px-10 lg:px-16 pb-24">
        <div className="text-sm text-[#5C544B] mb-8" data-testid="results-count">
          {loading ? "…" : `${properties.length} ${properties.length === 1 ? "immobile" : "immobili"}`}
        </div>

        {!loading && properties.length === 0 && (
          <div className="text-center py-20 text-[#8A8178]">{t.property.noResults}</div>
        )}

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-7">
          {properties.map((p, i) => <PropertyCard key={p.id} property={p} index={i} />)}
        </div>
      </section>
    </div>
  );
};

export default PropertiesPage;
